class VariationResponse {
  constructor({
    id,
    sku,
    wholesale_price,
    retail_price,
    image,
    createdAt,
    updatedAt,
    publishedAt,
    gem,
    metal,
    chain_type,
    chain_length,
    ring_sizes,
  }) {
    this.id = id;
    this.sku = sku;
    this.wholesalePrice = wholesale_price;
    this.retailPrice = retail_price;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.publishedAt = publishedAt;

    this.gem = gem;
    this.metal = metal;
    this.chainType = chain_type;
    this.chainLength = chain_length;
    if (ring_sizes) {
      this.ringSizes = ring_sizes.map((size) => size);
    }
    this.image = image;
  }
}
export default VariationResponse;
